/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AdminGetLeadsForCampaignResponseApiModel } from '../../models/admin-get-leads-for-campaign-response-api-model';

export interface GetLeadsForCampaign$Params {
  campaignId: string;
}

export function getLeadsForCampaign(http: HttpClient, rootUrl: string, params: GetLeadsForCampaign$Params, context?: HttpContext): Observable<StrictHttpResponse<AdminGetLeadsForCampaignResponseApiModel>> {
  const rb = new RequestBuilder(rootUrl, getLeadsForCampaign.PATH, 'get');
  if (params) {
    rb.path('campaignId', params.campaignId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AdminGetLeadsForCampaignResponseApiModel>;
    })
  );
}

getLeadsForCampaign.PATH = '/admin/campaigns/{campaignId}';
